import React from 'react';
import { FaBook, FaGamepad, FaFutbol, FaVolleyballBall, FaPaintBrush, FaMobileAlt } from 'react-icons/fa';

const Hobbies = () => (
  <div className="relative backdrop-blur-sm mb-10 z-20 sm:max-w-64 dark:bg-opacity-25 dark:bg-gray-700 p-4 rounded-lg shadow-2xl flex flex-col items-center text-center">
    <div className="grid grid-cols-2 gap-8">
      <div className="flex flex-col items-center">
        <FaBook className="text-4xl text-gray-200 dark:text-gray-100 mb-2" />
        <p className="text-lg text-gray-200 dark:text-gray-300">Reading</p>
      </div>
      <div className="flex flex-col items-center">
        <FaGamepad className="text-4xl text-gray-200 dark:text-gray-100 mb-2" />
        <p className="text-lg text-gray-200 dark:text-gray-300">Video Games</p>
      </div>
      <div className="flex flex-col items-center">
        <FaFutbol className="text-4xl text-gray-200 dark:text-gray-100 mb-2" />
        <p className="text-lg text-gray-200 dark:text-gray-300">Soccer</p>
      </div>
      <div className="flex flex-col items-center">
        <FaVolleyballBall className="text-4xl text-gray-200 dark:text-gray-100 mb-2" />
        <p className="text-lg text-gray-200 dark:text-gray-300">Volleyball</p>
      </div>
      <div className="flex flex-col items-center">
        <FaPaintBrush className="text-4xl text-gray-200 dark:text-gray-100 mb-2" />
        <p className="text-lg text-gray-200 dark:text-gray-300">Drawing</p>
      </div>
      <div className="flex flex-col items-center">
        <FaMobileAlt className="text-4xl text-gray-200 dark:text-gray-100 mb-2" />
        <p className="text-lg text-gray-200 dark:text-gray-300">Mobile Phone Customization</p>
      </div>
    </div>
  </div>
);

export default Hobbies;
